import { canAccessAppRoute } from '../router/access-policy';

function normalizeRole(role) {
  return (role || '').trim().replace(/[- ]+/g, '_').toUpperCase();
}

function toCanonicalWorkspaceRole(role) {
  const normalizedRole = normalizeRole(role);
  if (normalizedRole === 'TENANT_ADMIN') {
    return 'OWNER';
  }
  if (normalizedRole === 'ADMIN' || normalizedRole === 'ACCOUNT_MANAGER') {
    return 'MANAGER';
  }
  return normalizedRole;
}

function getBackendCapabilities(currentUser) {
  if (!currentUser?.capabilities || typeof currentUser.capabilities !== 'object') {
    return null;
  }

  return currentUser.capabilities;
}

export function getUserCapabilities({ currentUser, tenantAccess }) {
  const role = currentUser?.role || '';
  const normalizedRole = toCanonicalWorkspaceRole(role);
  const backendCapabilities = getBackendCapabilities(currentUser);
  const canAccessWorkspace =
    currentUser == null
      ? true
      : backendCapabilities?.canAccessWorkspace === true;
  const enabledModuleKeys = canAccessWorkspace
    ? backendCapabilities?.enabledModuleKeys ||
      (currentUser == null ? tenantAccess?.enabledModuleKeys || [] : [])
    : [];
  const canAccessStaffModule = enabledModuleKeys.includes('staff');
  const canAccessDocumentsModule = enabledModuleKeys.includes('documents');
  const canAccessDealsModule = enabledModuleKeys.includes('deals');
  const canAccessAccountingModule = enabledModuleKeys.includes('accounting');
  const isSuperAdmin = normalizedRole === 'SUPER_ADMIN';
  const canAccessPlatformAdmin = backendCapabilities?.canAccessPlatformAdmin === true;
  const canEnterWorkspaceAccess = backendCapabilities?.canEnterWorkspaceAccess === true;
  const canManageWorkspaceUsers = backendCapabilities?.canManageWorkspaceUsers === true;
  const canManageWorkspaceUserRoles = backendCapabilities?.canManageWorkspaceUserRoles === true;
  const canManageWorkspaceSettings = backendCapabilities?.canManageWorkspaceSettings === true;
  const canManageStaffDestructiveActions =
    backendCapabilities?.canManageStaffDestructiveActions === true && canAccessStaffModule;
  const canManageDocumentDestructiveActions =
    backendCapabilities?.canManageDocumentDestructiveActions === true && canAccessDocumentsModule;
  const canManageDealDestructiveActions =
    backendCapabilities?.canManageDealDestructiveActions === true && canAccessDealsModule;
  const canManageAccountingDestructiveActions =
    backendCapabilities?.canManageAccountingDestructiveActions === true && canAccessAccountingModule;

  return {
    isSuperAdmin,
    canAccessPlatformAdmin,
    canEnterWorkspaceAccess,
    tenantActive: backendCapabilities?.tenantActive === true,
    membershipStatus: backendCapabilities?.membershipStatus || '',
    enabledModuleKeys,
    canAccessWorkspace,
    isCapabilityUnavailable: Boolean(currentUser && !backendCapabilities),
    canCreateStaff: backendCapabilities?.canCreateStaff === true && canAccessStaffModule,
    canManageStaffDestructiveActions,
    canManageDocumentDestructiveActions,
    canManageDealDestructiveActions,
    canManageAccountingDestructiveActions,
    canManageWorkspaceUsers,
    canManageWorkspaceUserRoles,
    canManageWorkspaceSettings,
  };
}

export function canAccessRoute({ route, currentUser, tenantAccess, capabilities = {} }) {
  return canAccessAppRoute({
    route,
    currentUser,
    tenantAccess,
    capabilities,
  });
}
